const name = 'circle-x';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path fill="#FFF" d="M24.081 55h-5.8l9.032-14.666-8.369-13.505h6.297l3.066 4.971 2.569 5.386h.414l2.486-5.386 2.983-4.971h6.048l-8.451 13.505L43.719 55h-6.463l-4.06-6.214-2.569-5.137h-.414l-2.403 5.137z"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'X',
};

export default icon;
